export interface TenantContactVO {
  accountId?: string;
  age?: number;
  alias?: string;
  avatarId?: string;
  avatarUrl?: string;
  fallbackAvatarUrl?: string;
  birthday?: string;
  bloodType?: BloodType;
  businessCardId?: string;
  channel?: Channel;
  company?: string;
  companyAddress?: string;
  companyDepartment?: string;
  companyDuty?: string;
  companyEmail?: string;
  companyPhone?: string;
  createTime?: number;
  description?: string;
  email?: string;
  gender?: Gender;
  id?: string;
  interests?: string;
  isAileCompany?: boolean;
  isBindAile?: boolean;
  isCollectInfo?: boolean;
  isJoinAile?: boolean;
  languages?: Language[];
  maritalStatus?: MaritalStatus;
  name?: string;
  openId?: string;
  parentAddressBookId?: string;
  phone?: string;
  roomId?: string;
  status?: Status;
  tenantId?: string;
  type?: ContactType;
  updateTime?: number;
  [property: string]: any;
}

export enum BloodType {
  A = 'A',
  Ab = 'AB',
  B = 'B',
  O = 'O'
}

export enum Channel {
  Admin = 'Admin',
  Ai = 'Ai',
  Aile = 'Aile',
  AileLite = 'AileLite',
  Aiwow = 'Aiwow',
  Anonymous = 'Anonymous',
  Cbm = 'Cbm',
  Facebook = 'Facebook',
  Google = 'Google',
  Instagram = 'Instagram',
  Internal = 'Internal',
  Line = 'Line',
  Webchat = 'Webchat'
}

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
  Unknown = 'Unknown'
}

export enum Language {
  EnUs = 'EN_US',
  ZhCN = 'ZH_CN',
  ZhTw = 'ZH_TW'
}

export enum MaritalStatus {
  Divorced = 'Divorced',
  Married = 'Married',
  Single = 'Single',
  Widowed = 'Widowed'
}

export enum Status {
  Audit = 'Audit',
  Delete = 'Delete',
  Disable = 'Disable',
  Enable = 'Enable',
  New = 'New'
}

export enum ContactType {
  RealName = 'RealName',
  Anonymous = 'Anonymous',
  Independent = 'Independent'
}

export interface TenantContactListRequest {
  tenantId: string;
  direction?: string;
  key?: string;
  orderBy?: string;
  pageIndex?: number;
  pageSize?: number;
  refreshTime?: number;
  serviceNumberId?: string;
}

export interface TenantContactJourneyRequest {
  tenantId: string;
  contactId: string;
  pageIndex?: number;
  pageSize?: number;
  sessionStartTimeFrom?: number;
  sessionStartTimeTo?: number;
}

export interface TenantContactSessionRequest extends TenantContactJourneyRequest {
  roomId: string;
}
export interface TenantContactMessageRequest {
  tenantId: string;
  contactId: string;
  roomId: string;
  sessionId: string;
  direction?: 'asc' | 'desc';
  pageSize?: number;
  sequence?: number;
  lastSequence?: number;
}
export interface ServiceRoomJourneyVO {
  serviceNumberId: string;
  serviceNumberName?: string;
  roomId: string;
  firstSessionStartTime?: number;
  latestSessionStartTime?: number;
  inboundCount?: number;
}
export interface SessionJourneyVO {
  sessionId: string;
  serviceNumberId?: string;
  roomId: string;
  status?: string;
  channel?: string;
  sessionStartTime?: number;
  nextSessionStartTime?: number;
  distributeTime?: number;
  agentFirstMessageTime?: number;
  robotEndTime?: number;
  endTime?: number;
  agentId?: string;
  hasRobot?: boolean;
  hasTransferredToAgent?: boolean;
  inboundReasonName?: string;
  inboundReasonDescription?: string;
  satisfactionScore?: number;
  satisfactionFeedback?: string;
  hasSatisfaction?: boolean;
}
export interface SessionMessageVO {
  id: string;
  sessionId?: string;
  senderName?: string;
  senderId?: string;
  accountId?: string;
  sourceType?: string;
  type?: string;
  content?: string;
  sendTime?: number;
  sequence: number;
}
